import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './core/bin/serviceWorker';
import { IntlProvider } from 'react-intl';
import i18n from './core/bin/i18n.js';

import Header from './components/Header';
import TopicSelector from './components/TopicSelector';
import TopicProvider from './context/topicContext';
import { isMobileOnly } from 'react-device-detect';

import Carousel from './components/Carousel';
import DetailsProvider from './context/detailsContext';
import CarouselProvider from './context/carouselContext';
import { BreakpointProvider } from './context/breakpoint';
import { queries } from './utils/mediaQuery';

/**
 * Renders the widget.
 *
 * It renders a react application as the widget.
 *
 * @param {string} instanceId
 *   The already present HTML element ID where the react app will be rendered.
 * @param {string} langCode
 *   The language code for internationalization purposes.
 * @param {string} origin
 *   Protocol and hostname where a JSONAPI endpoint is available.
 * @param {Function} cb
 *   A callback that executes after the widget has been rendered.
 */
function render(instanceId, langCode, origin, cb) {
  const element = document.getElementById(instanceId);
  const translation = new i18n(langCode || serviceWorker.getUrlLocale());
  const charts = require('./data/charts.json');

  ReactDOM.render(
    <React.StrictMode>
      <IntlProvider locale={translation.locale} messages={translation.messages}>
        <DetailsProvider>
          <TopicProvider>
            <div className="ibm-widget-serverless-dv">
              <div className="supertopics-main-wrapper">
                <div
                  className={`supertopics-container${
                    isMobileOnly ? ' isMobile' : ''
                  }`}>
                  <Header />
                  <TopicSelector messages={translation.messages} />
                </div>

                <BreakpointProvider queries={queries}>
                  <CarouselProvider>
                    <Carousel messages={charts} />
                  </CarouselProvider>
                </BreakpointProvider>
              </div>
            </div>
          </TopicProvider>
        </DetailsProvider>
      </IntlProvider>
    </React.StrictMode>,
    element,
    () => cb(element),
  );
  serviceWorker.unregister();
}

window.renderIbmServerlessDv = render;
